// src/services/stationTypeService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getStationTypes = async () => {
  return await axios.get(`${API_URL}/station-types`);
};

const getStationType = async (id) => {
  return await axios.get(`${API_URL}/station-types/${id}`);
};

const createStationType = async (stationTypeData) => {
  return await axios.post(`${API_URL}/station-types`, stationTypeData);
};

const updateStationType = async (id, stationTypeData) => {
  return await axios.put(`${API_URL}/station-types/${id}`, stationTypeData);
};

const deleteStationType = async (id) => {
  return await axios.delete(`${API_URL}/station-types/${id}`);
};

export default {
  getStationTypes,
  getStationType,
  createStationType,
  updateStationType,
  deleteStationType,
};
